var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 9C17.4 9.74088 17.1894 10.8389 16.8129 12.1015C16.44 13.3522 15.9176 14.721 15.3243 15.9882C14.729 17.2595 14.073 18.4055 13.4393 19.2235C13.1218 19.6333 12.8248 19.9414 12.5599 20.1419C12.2884 20.3476 12.1043 20.4 12 20.4C11.956 20.4 11.809 20.3677 11.546 20.1543C11.297 19.9524 11.0098 19.6415 10.697 19.2286C10.0733 18.4055 9.40553 17.2544 8.79019 15.9815C8.17647 14.7119 7.62496 13.3421 7.22815 12.0915C6.827 10.8273 6.6 9.73412 6.6 9C6.6 6.01766 9.01766 3.6 12 3.6C14.9823 3.6 17.4 6.01766 17.4 9Z",
    stroke: "#C1C4CB",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.14404,
    r: 2.25,
    fill: "#C1C4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b460b45436e663cf6e5ea38e6694f4ee.svg";
export { ForwardRef as ReactComponent };